<template>
    <div class="container px-0">
        <div class="row">
            <div class="col-12">

                <div class="flex-table">
                    <!--Expiration-->
                    <div class="flex-table--row">
                        <div class="flex-table--cell flex-table--cell-grow-always">
                            <h5 class="text-secondary">Expires</h5>
                        </div>
                        <div class="flex-table--cell">
                            <label class="toggle">
                                <input type="checkbox" v-model="expires">
                                <span class="toggle--slider"></span>
                            </label>
                        </div>
                    </div>

                    <!--Expiration period-->
                    <div class="flex-table--row" v-if="expires">
                        <div class="flex-table--cell flex-table--cell-grow-always">
                            <h5 class="text-secondary">Expiration period</h5>
                        </div>
                        <div class="flex-table--cell">
                            <input type="number" class="form-control main-modal--input mr-2" min="1" v-model="expiration_period">
                            <select class="form-control main-modal--input" v-model="expiration_method">
                                <option value="day">Day(s)</option>
                                <option value="week">Week(s)</option>
                                <option value="month">Month(s)</option>
                            </select>
                        </div>
                    </div>

                    <!--Expiration day-->
                    <div class="flex-table--row" v-if="expires && expiration_method === 'week'">
                        <div class="flex-table--cell flex-table--cell-grow-always">
                            <h5 class="text-secondary">Day of the week</h5>
                        </div>
                        <div class="flex-table--cell">
                            <select class="form-control main-modal--input" v-model="date">
                                <option :value="0">Monday</option>
                                <option :value="1">Tuesday</option>
                                <option :value="2">Wednesday</option>
                                <option :value="3">Thursday</option>
                                <option :value="4">Friday</option>
                                <option :value="5">Saturday</option>
                                <option :value="6">Sunday</option>
                            </select>
                        </div>
                    </div>

                    <!--Repeats-->
                    <div class="flex-table--row" v-if="expires">
                        <div class="flex-table--cell flex-table--cell-grow-always">
                            <h5 class="text-secondary">Repeats</h5>
                        </div>
                        <div class="flex-table--cell">
                            <label class="toggle">
                                <input type="checkbox" v-model="repeats">
                                <span class="toggle--slider"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
	export default {
		name: "FormAlertsComponent",
        props: [
        	'value'
        ],

        data(){
			return {
				expires: false,
				expiration_period: 1,
				expiration_method: 'week',
				repeats: true,
				date: 0,
            }
        },

        mounted(){
			this.expires = this.value.expires ?? false;
			this.repeats = this.value.repeats ?? true;
			this.date = this.value.first_day ?? 0;

			if (this.value.expiration_period) {
				this.expiration_method = this.value.expiration_method;
				this.expiration_period = this.value.expiration_period;
            }
        },

        methods: {
			save(){
				let _build = Object.assign({}, this.value || {});
				_build.expires = this.expires;
				_build.repeats = this.repeats;
				_build.first_day = this.date;
				_build.expiration_method = this.expiration_method;
				_build.expiration_period = this.expiration_period;

                this.$emit('input', _build);
            }
        },

        watch: {
			expires(){ this.save(); },
			expiration_period(){ this.save(); },
			expiration_method(){ this.save(); },
			repeats(){ this.save(); },
			date(){ this.save(); }
        }
	}
</script>
